import { apiClient } from './client';

export const FEATURE_FLAG_KEYS = [
    'publisherResultImports.reviewFlow',
    'reportImports.docxImport',
    'reportImages.blocks',
] as const;

export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number];

export type FeatureFlagDecisionReason =
    | 'default'
    | 'disabled'
    | 'global'
    | 'targeted'
    | 'percentage'
    | 'error';

export type FeatureFlagDecision = {
    flag: FeatureFlagKey;
    enabled: boolean;
    reason: FeatureFlagDecisionReason;
};

type FeatureFlags = Partial<Record<FeatureFlagKey, FeatureFlagDecision>>;

type FeatureFlagsEnvelope = {
    data: {
        flags: FeatureFlags;
    };
};

export const featureFlagsApi = {
    getFeatureFlags: async (): Promise<FeatureFlags> => {
        const response = await apiClient.get<FeatureFlagsEnvelope>('/me/feature-flags');

        return (response as unknown as FeatureFlagsEnvelope).data.flags;
    },
};
